import JsBarcode from "jsbarcode";

// Lienzo blanco para cuando no hay código que pintar (o JsBarcode falla).
export function canvasBlanco(): string {
  const canvas = document.createElement("canvas");
  canvas.width = 200;
  const ctx = canvas.getContext("2d");
  if (ctx) {
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
  return canvas.toDataURL("image/png");
}

// Genera un PNG (dataURL) con un código de barras CODE128 del texto dado.
// Devuelve un canvas en blanco si el texto está vacío o si JsBarcode falla.
export function generarCodigoBarras(texto: string | null | undefined): string {
  const textoLimpio = texto?.toString().trim().replace(/^0+./, "");

  if (!textoLimpio || textoLimpio === "null" || textoLimpio === "undefined") {
    return canvasBlanco();
  }

  try {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, textoLimpio, {
      format: "CODE128",
      width: 2,
      displayValue: false,
      fontSize: 12,
      margin: 5,
      background: "#ffffff",
      lineColor: "#000000",
      valid: () => {},
    });
    return canvas.toDataURL("image/png");
  } catch {
    return canvasBlanco();
  }
}
